import templateUrl from './message.html';

export default {
  templateUrl,
  transclude: {
    actionButtons: '?actionButtons'
  },
  bindings: {
    content: '<',
    title: '@'
  },
  controller: class MessageComponent {
    constructor() {
      'ngInject';
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/dashboard/message/message.component.js